var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('base-container',{class:["button-group-demo"]},[_c('view-desc',[_vm._v("水平排列")]),_c('button-group-two'),_c('view-desc',[_vm._v("垂直排列")]),_c('button-group-vertical-two'),_c('view-desc',[_vm._v("图文结合")]),_c('button-group-with-context')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }